<template>
    <KpTooltip :disabled="!tooltip">
        <template #activator="{ on, attrs }">
            <v-icon
                :class="classObject"
                :title="title"
                v-bind="{ ...$attrs, ...attrs }"
                v-on="{ ...$listeners, ...on }"
            />
        </template>
        {{ tooltip || null }}
    </KpTooltip>
</template>

<script>
import KpTooltip from './KpTooltip.vue';
export default {
    components: { KpTooltip },
    props: {
        /** a size as defined in the CSS ic-* classes (e.g. '20' for the ic-20 class) */
        size: {
            type: String,
            default: '',
        },

        /** the icon class name, e.g. 'star' */
        iconCls: {
            type: String,
            default: '',
        },

        color: {
            type: String,
            default: null,
        },
        activeColor: {
            type: String,
            default: null,
        },
        disabledColor: {
            type: String,
            default: null,
        },

        /** a small right-padding, if used left of an item */
        left: Boolean,

        /** a small left-padding, if used right of an item */
        right: Boolean,

        title: {
            type: String,
            default: '',
        },

        tooltip: {
            type: String,
            default: '',
        },
    },
    computed: {
        classObject() {
            return {
                ic: true,
                [`ic-${this.size || 20}`]: true,
                [`ic-${this.iconCls}`]: true,
                [`ic-col-${this.color}`]: this.color,
                [`ic-col-active-${this.activeColor}`]: this.activeColor,
                [`ic-col-disabled-${this.disabledColor}`]: this.disabledColor,
                'mr-1': this.left,
                'ml-1': this.right,
            };
        },
    },
};
</script>
